var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-cta font-weight-bold",on:{"click":function($event){return _vm.$router.push({name: _vm.route})}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }